import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const PageUnderConstruction = ({ text = 'under construction', className = 'flex items-center justify-center h-full opacity-25', description }) => (
  <div className={className}>
    <Box className='py-4 px-6 flex flex-col items-center justify-center'>
      <FontAwesomeIcon icon="triangle-person-digging" className='text-muted-foregroud text-9xl text-center' />
      <Typography align='center' variant='inherit' className='text-muted-foregroud uppercase text-2xl'>{text}</Typography> 
      {description && <Typography align='center' variant='body2' className='text-muted-foregroud opacity-90 mt-2'>{description}</Typography>}
    </Box>
  </div>
)
export default  PageUnderConstruction
